<template>
  <sidebar
    :addTitle="$t('Drilling.Contracts.AddNew')"
    :editTitle="$t('Drilling.Contracts.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col  vs-w="12">
            <ValidationProvider :name="$t('Drilling.Contracts.Code')" :rules="{ required: true, uniqueContractCode: { contractId: contractContractId } }" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Contracts.Code')"
                v-model="contractCode"
                name="code"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
           <vs-col  vs-w="12">
            <ValidationProvider :name="$t('Drilling.Contracts.Location')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Contracts.Location')"
                v-model="contractLocation"
                name="location"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
           <vs-col  vs-w="12">
            <ValidationProvider :name="$t('Drilling.Contracts.Property')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Contracts.Property')"
                v-model="contractProperty"
                name="property"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
           <vs-col  vs-w="12">
            <ValidationProvider :name="$t('Drilling.Contracts.State')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Contracts.State')"
                v-model="contractState"
                name="state"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.Companies.Name')}}</form-label>
            <ValidationProvider :name="$t('Drilling.Companies.Name')" rules="required" v-slot="{ errors }">
              <v-select
                label="name"
                :options="companies"
                :reduce="c => c.companyId"
                v-model="contractCompanyId"
                class="w-full"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../shared/components";
import vSelect from 'vue-select';
import { extend } from 'vee-validate';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    'v-select': vSelect
  },
  created() {
    const vm = this;
    extend('uniqueContractCode', {
      params: ['contractId'],
      message: this.$t('Drilling.Contracts.CodeNotUnique'),
      validate: (value, { contractId }) => {
        const contracts = vm.$store.state.drilling.contracts;
        const id = Number(contractId) || 0;
        return contracts.every(c => c.code === null || c.code.toLowerCase() !== value.toLowerCase() || c.contractId === id);
      }
    });
  },
  data() {
    return {
      contractContractId: 0,
      contractMainProjectId: 0,
      contractCode: "",
      contractLocation: "",
      contractProperty: "",
      contractState: "",
      contractCompanyId: 0,
      contractVendor: ""
    };
  },
  computed : {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    companies() {
      return this.$store.state.drilling.companies;
    },
    mainProjectId() {
      return Number(this.$store.state.projectId);
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {contractId, mainProjectId, code, location, property, state, vendor, companyId } = JSON.parse(JSON.stringify(this.data));
      this.contractContractId = contractId;
      this.contractMainProjectId = mainProjectId;
      this.contractCode = code;
      this.contractLocation = location;
      this.contractProperty = property;
      this.contractState = state;
      this.contractCompanyId = companyId;
      this.contractVendor = vendor;
 
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.contractId) return;

      this.contractContractId = 0;
      this.contractMainProjectId = this.mainProjectId;
      this.contractCode = '';
      this.contractLocation = '';
      this.contractProperty = '';
      this.contractState = '';
      this.contractCompanyId = null;
      this.contractVendor = '';
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            contractId : this.contractContractId, 
            mainProjectId: this.contractMainProjectId,
            code : this.contractCode, 
            location : this.contractLocation, 
            property : this.contractProperty, 
            state : this.contractState, 
            vendor : this.contractVendor, 
            companyId : this.contractCompanyId
          };

          if (this.contractContractId !== null && this.contractContractId > 0) {
            this.$store.dispatch("drilling/updateContract", obj).then((response) => {
              this.$emit("onContractUpdated", response.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("drilling/addContract", obj).then((response) => {
              this.$emit("onContractInserted", response.data);
              this.contractContractId = response.data.contractId;
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
